import { UNICEF_BLUE, DARK_GRAY } from "../../../constants/color";

export const commonHeaderStyle: any = {
  backgroundColor: `${UNICEF_BLUE}`,
  color: `${DARK_GRAY}`,
  whiteSpace: "nowrap",
  fontWeight: 500,
  fontSize: "14px",
  padding: "10px 15px",
};
export const commonHeaderStyleDarker = {
  backgroundColor: "#c7eaf7",
};
export const commonTableStyle = {
  minWidth: "650px",
  overflow: "auto",
  boxShadow: "none",
};

export const commonCellStyle = {
  padding: "2px 15px",
  fontSize: "14px",
};
